<template>
    <a :href="target" ref="topnotification" v-view="viewHandler" id="notificationbar"
        class="relative w-full left-0 bg-primary text-white z-50 flex items-center sm:justify-center text-sm uppercase overflow-hidden hover:bg-gradient dark:hover:border-neutral-900 cursor-pointer transition duration-300 transition-all h-14 sm:h-8 hover:h-12"
        :class="[show ? '' : 'h-0 duration-500']">
        <div class="scroll flex sm:block">
            <p v-for="n in 10" :class="[n != 1 ? 'sm:hidden' : '']">
                {{ message }}
            </p>
        </div>
    </a>
</template>

<script>
export default {
    data() {
        return {
            status: this.$attrs.status ?? 'error',
            duration: this.$attrs.duration ?? null,
            message: this.$attrs.message ?? 'Something went wrong',
            target: this.$attrs.target ?? '',
            show: false,
        };
    },
    methods: {
        setThemeColor(color) {
            const meta = document.querySelector(`meta[name="theme-color"]`);
            if (meta) meta.setAttribute("content", color);
        },
        viewHandler(e) {
            const dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            const activeColor = dark ? this.$main_color_darkmode : this.$main_color;
            const defaultColor = dark ? '#171717' : '#ffffff';

            if (this.duration == null) {
                if (e.percentInView > 0) {
                    document.body.style.backgroundColor = activeColor;
                    this.setThemeColor(activeColor);
                } else {
                    document.body.style.backgroundColor = defaultColor;
                    this.setThemeColor(defaultColor);
                }
            }
        },
    },
    mounted() {
        const dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const activeColor = dark ? this.$main_color_darkmode : this.$main_color;

        if (this.duration != null) {
            this.$refs.topnotification.classList.add('transition-all', 'duration-500');
            this.show = true;
            setTimeout(() => (this.show = false), this.duration);
        } else {
            this.show = true;
            document.body.style.backgroundColor = activeColor;
            this.setThemeColor(activeColor);
        }
    },
};
</script>
